<script lang="ts">
import { Options, Vue } from "vue-property-decorator";
import { usePatientHistoryDataviewStore } from "@/stores/modules/dataview";

@Options({
    components: {},
})
export default class PatientHistoryTabAcu extends Vue {
    store = usePatientHistoryDataviewStore();

    get consultation() {
        return this.store.currentConsultation?.consultation;
    }

    get acu() {
        return this.store.currentConsultation?.acu;
    }
}
</script>

<template lang="pug">
el-tab-pane#patient-history-tab-acu(label="針灸")
    .tab-container
        el-row 
            el-col
                el-form-item
                    el-input(v-model="acu" type="textarea" :autosize="{minRows: 10}" disabled)

</template>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.tab-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
